/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore Tools`)
};

const es_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar herramientas`)
};

const de_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkzeuge entdecken`)
};

const nl_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools verkennen`)
};

const fr_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer les outils`)
};

const it_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora gli strumenti`)
};

const pt_br2_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar ferramentas`)
};

const pt_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar ferramentas`)
};

const ja_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールを探す`)
};

const zh_home_hero_cta_explore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_cta_explore = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_cta_explore(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_hero_cta_explore", locale)
	if (locale === "en") return en_home_hero_cta_explore(inputs)
	if (locale === "es") return es_home_hero_cta_explore(inputs)
	if (locale === "de") return de_home_hero_cta_explore(inputs)
	if (locale === "nl") return nl_home_hero_cta_explore(inputs)
	if (locale === "fr") return fr_home_hero_cta_explore(inputs)
	if (locale === "it") return it_home_hero_cta_explore(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_cta_explore(inputs)
	if (locale === "pt") return pt_home_hero_cta_explore(inputs)
	if (locale === "ja") return ja_home_hero_cta_explore(inputs)
	return zh_home_hero_cta_explore(inputs)
};